export const TRIAL_EXTENSION_HOURS = {
  ONE_HOUR: '1',
  TWO_HOURS: '2',
  FOUR_HOURS: '4',
  SIX_HOURS: '6',
  TWELVE_HOURS: '12',
  TWENTY_FOUR_HOURS: '24',
  FORTY_EIGHT_HOURS: '48',
} as const;

export const DEFAULT_TRIAL_EXTENSION_HOURS = TRIAL_EXTENSION_HOURS.TWO_HOURS;
export const MAX_TRIAL_EXTENSION_HOURS = TRIAL_EXTENSION_HOURS.FORTY_EIGHT_HOURS;
